import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_AiBabyGenerator = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/ai-baby-generator',
			name: 'AI Baby Generator — See Your Future Child with Lift',
			description:
				'Upload two photos and generate a lifelike baby, child, or teen portrait with Lift. Adjust gender and age settings, regenerate anytime. Try the AI baby generator now',
			url: 'https://liftapp.ai/ai-baby-generator',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/ai-baby-generator#product' },
				{ '@id': 'https://liftapp.ai/ai-baby-generator#howto' },
				{ '@id': 'https://liftapp.ai/ai-baby-generator#benefits' },
				{ '@id': 'https://liftapp.ai/ai-baby-generator#faq' },
				{ '@id': 'https://liftapp.ai/ai-baby-generator#why-lift' },
				{ '@id': 'https://liftapp.ai/ai-baby-generator#explore-tools' },
				{ '@id': 'https://liftapp.ai/ai-baby-generator#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/ai-baby-generator#product',
			name: 'AI Baby Generator',
			description:
				'Upload two photos and generate a lifelike baby, child, or teen portrait with Lift. Adjust gender and age settings, regenerate anytime',
			url: 'https://liftapp.ai/ai-baby-generator',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: 4.8,
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/ai-baby-generator#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your images',
					text: 'Choose two clear photos from your device to start your baby prediction',
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Generate your result',
					text: 'Lift creates a lifelike child image from both photos using AI',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Adjust the settings',
					text: 'Switch gender and age options, replace photos, or generate again',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and use',
					text: 'Save your result or share it with friends on social media',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-baby-generator#benefits',
			name: 'Who can benefit from the AI Baby Generator?',
			description:
				"Lift's AI Baby Generator is useful for couples, social media users, friends, and casual AI explorers who want to preview a realistic AI-generated child portrait from two photos.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Couples can upload a photo each and preview a realistic AI-generated portrait of their future child',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Social media users can generate a polished, AI-produced baby image worth sharing in seconds',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Friends and gift seekers can create a fun, personalized baby prediction for someone they know',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Casual AI explorers can upload two photos and see results instantly with no technical knowledge required',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Mobile users can use the AI baby generator smoothly on any device and regenerate with a single tap',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.3da6de53.webp',
				name: 'AI Baby Generator by Lift',
				description:
					'Illustration of AI Baby Generator blending two parent photos to create realistic baby portraits with different possible outcomes.',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/ai-baby-generator#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI Baby Generator?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift AI Baby Generator is a online tool that creates realistic baby portraits from two uploaded photos. It uses artificial intelligence to blend facial features and generate a lifelike preview of what a future child may look like — across different genders and age stages.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift AI Baby Generator work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Upload one photo of each parent, then tap Generate Baby. Lift AI analyzes both images and produces a realistic child portrait. You can adjust the gender setting and the age stage. Replace either photo and generate again at any time.',
					},
				},
				{
					'@type': 'Question',
					name: "Can I choose the child's gender and age?",
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes. Lift AI Baby Generator lets you generate results for a boy, girl, or prediction, and preview different age stages such as baby, child, and teen.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, print, ads, or e-commerce.",
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-baby-generator#why-lift',
			name: "Why Lift's AI Baby Generator stands out",
			description:
				"Lift's AI Baby Generator combines professional-grade AI, ease of use, and affordability — making it a trusted choice for millions of users worldwide.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality results',
					description:
						'AI-powered technology delivers professional-grade visuals every time',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent rendering',
					description:
						'AI tailors the effect to the scene and subject for optimal results',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly designers with an affordable and intuitive tool',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.ae83a89c.webp',
				name: 'Why use Lift AI Baby Generator',
				description:
					'Example of AI Baby Generator showing a baby portrait created from two parent photos with realistic blended facial features and social reactions icons.',
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-baby-generator#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/ai-baby-generator#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in/?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in/?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'AI Baby Generator',
					item: 'https://liftapp.ai/ai-baby-generator',
				},
			],
		},
	],
};
